function panic() {

    console.log('lifecycle :', 'panic demo scene');

    this.load('loading');
}

export {panic};
